import React from 'react';
import PropTypes from 'prop-types';
import ZoomToButton from './ZoomToButton';
import './Headstone.css';

const gravestone = ({ name, dob, dod, id, unselectGravestone, n }) => {
  return (
    <div
      id='headstoneInfo'
    >
      <div className='overflowContainer'>
        <div className='buttons'>
          <ZoomToButton />
          <button
            onClick={unselectGravestone}
            className='close'
          >
            <svg
              width={25}
              height={25}
            >
              <g transform='rotate(45 12.5 12.5)'>
                <line
                  x1='15%'
                  x2='85%'
                  y1='50%'
                  y2='50%'
                  strokeWidth='7.5%'
                  stroke='#262626'
                />
                <line
                  x1='50%'
                  x2='50%'
                  y1='15%'
                  y2='85%'
                  strokeWidth='7.5%'
                  stroke='#262626'
                />
              </g>
            </svg>
          </button>

        </div>
        <h2>{name}</h2>
        <div className='lifespan'>{`${dob} - ${dod}`}</div>
        <p className='findAGrave'>
          A photo of the grave marker and more information is available on the <a href={`https://www.findagrave.com/memorial/${id}`} target='_blank' rel='noopener noreferrer'>Find A Grave</a> website.
        </p>
        {(n) && 
          <p>
            {n}
          </p>
        }
      </div>
    </div>
  );
};

export default gravestone;

gravestone.propTypes = {
  name: PropTypes.string,
  dob: PropTypes.string,
  dod: PropTypes.string,
  id: PropTypes.number,
  unselectGravestone: PropTypes.func,
};

gravestone.defaultProps = {
  
};



// WEBPACK FOOTER //
// ./src/components/Headstone.jsx